<div class="modal-container">
  <h2>{{ "UserManagementDeleteTitle" | translate }}</h2>
  <mat-dialog-content class="mat-typography">
    <p>
      {{ "UserManagementDeleteDescription" | translate }}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="modal-buttons">
      <button id="confirm-delete-user" [mat-dialog-close]="true">
        {{ "UserManagementDeleteConfirm" | translate }}
      </button>
      <button id="cancel-delete-user" mat-button [mat-dialog-close]="false">
        {{ "UserManagementDeleteCancel" | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
